<div class="tools-container" [formGroup]="toolsFormGroup">
  <h4 class="tools-title">{{ 'PRESENTER.TEAM_SCORING_TOOLS.TITLE' | translate }}</h4>

  <div class="tools-row">
    <mat-form-field>
      <mat-label>{{ 'PRESENTER.TEAM_SCORING_TOOLS.ROWS' | translate }}</mat-label>
      <input matInput type="number" [formControl]="rowsControl" min="1" />
    </mat-form-field>
  </div>

  <mat-form-field>
    <mat-label>{{ 'PRESENTER.TEAM_SCORING_TOOLS.PAGE_SHOW_DURATION' | translate }}</mat-label>
    <input matInput type="number" [formControl]="slideIntervalControl" min="1" />
  </mat-form-field>

  <gb-token-color-picker
    circleDiameter="38px"
    [control]="tablePrimaryColorControl"
    labelTranslateKey="PRESENTER.TEAM_SCORING_TOOLS.PRIMARY_COLOR"
    cpPosition="right"
    [showDropdown]="true"
  ></gb-token-color-picker>

  <gb-token-color-picker
    circleDiameter="38px"
    [control]="tableAccentColorControl"
    labelTranslateKey="PRESENTER.TEAM_SCORING_TOOLS.ACCENT_COLOR"
    cpPosition="right"
    [showDropdown]="true"
  ></gb-token-color-picker>

  <div class="opacity-slider-container">
    <label class="opacity-label">{{ 'PRESENTER.TEAM_SCORING_TOOLS.OPACITY' | translate }}</label>
    <div class="slider-wrapper">
      <mat-slider min="0" max="1" step="0.01" discrete>
        <input matSliderThumb [formControl]="opacityControl" />
      </mat-slider>
      <span class="opacity-value">{{ opacityControl.value }}</span>
    </div>
  </div>

  <gb-presenter-tools-text [toolsFormGroup]="toolsFormGroup" [hideFields]="hideFields"></gb-presenter-tools-text>

  <mat-form-field>
    <mat-label>{{ 'PRESENTER.TEAM_SCORING_TOOLS.BORDER_WIDTH' | translate }}</mat-label>
    <input matInput type="number" [formControl]="borderWidthControl" min="0" />
  </mat-form-field>

  <gb-token-color-picker
    circleDiameter="38px"
    [control]="borderColorControl"
    labelTranslateKey="PRESENTER.TEAM_SCORING_TOOLS.BORDER_COLOR"
    cpPosition="right"
    [showDropdown]="true"
  ></gb-token-color-picker>

  <mat-form-field>
    <mat-label>{{ 'PRESENTER.TEAM_SCORING_TOOLS.BORDER_STYLE' | translate }}</mat-label>
    <mat-select [formControl]="borderStyleControl">
      @for (option of borderStyles; track option.value) {
        <mat-option [value]="option.value">{{ option.label | translate }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <button mat-stroked-button type="button" class="filter-teams-button" (click)="openFilterTeamsDialog()">
    <span class="button-inner">
      <gb-icon icon="filter" height="18px"></gb-icon>
      <span>{{ 'PRESENTER.TEAM_SCORING_TOOLS.FILTER_TEAMS.BUTTON' | translate }}</span>
    </span>
  </button>
</div>
